import { Component } from '@angular/core';
import { EventsModule } from '../../../../events/events.module';
import { LayoutModule } from '../../../layout/layout.module';

@Component({
  selector: 'app-tickets-dashboard-page',
  standalone: true,
  imports: [
    LayoutModule,
    EventsModule,
  ],
  templateUrl: './tickets-dashboard-page.component.html',
  styleUrl: './tickets-dashboard-page.component.sass',
})
export class TicketsDashboardPageComponent { }
